<template>
    <div class="service-box">
        <div class="container">
            <el-container>
                <el-aside 
                    width="200px"
                    class="service-aside">
                    <el-menu
                        mode="vertical"
                        :default-active="$route.path"
                        background-color="#fff"
                        active-text-color="#FF6700"
                        class="service-menu"
                        router>
                        <!-- 维修服务 -->
                        <el-menu-item index="/service/repair">
                            <template #title>
                                <div>{{$t("message.service.menu1")}}</div>
                            </template>
                        </el-menu-item>
                        <!-- 文件货物寄存 -->
                        <el-menu-item index="/service/deposit">
                            <template #title>
                                <div>{{$t("message.service.menu2")}}</div>
                            </template>
                        </el-menu-item>
                        <!-- 文件货物代送 -->
                        <el-menu-item index="/service/delivery">
                            <template #title>
                                <div>{{$t("message.service.menu3")}}</div>
                            </template>
                        </el-menu-item>
                    </el-menu>
                </el-aside>
                <el-main>
                    <div class="service-view">
                        <router-view></router-view>
                    </div>
                </el-main>
            </el-container>
        </div>
    </div>
</template>

<script>
export default {
    
}
</script>

<style scoped>
.service-aside{
    min-height: 600px;
}
.service-menu{
    height: 100%;
}
</style>